import { ConfigurationSourceDataMap, ConfigurationStatus, CoordinatingGroup, Institution, MasterGroup, Metadata, Participant, SourceData, SourceDataEventStatus, SourceDataFormStatus, Trial } from "@/api/dtos";
import { useMemo } from "react";
import { createItemGroupConfiguration } from "../configuration/useItemGroupConfiguration";

export const createItemGroup = (
    metadata?: Metadata, 
    trialConfigurationItems?: ConfigurationSourceDataMap['itemGroups'], 
    configurationItems?: ConfigurationSourceDataMap['itemGroups'], 
    sourceDataItems?: SourceData['items'], 
    trial?: Trial, 
    masterGroup?: MasterGroup,
    coordinatingGroup?: CoordinatingGroup,
    institution?: Institution,
    participant?: Participant,
    isGlobal?: boolean,
    configurationSourceDataId?: number, 
    studyEventOid?: string,
    studyEventRepeat?: number,
    caseReportFormOid?: string,
    caseReportFormVersionOid?: string,
    itemGroupName?: string,
    itemGroupRepeat?: number,
    preview?: boolean
) => {
    if (!studyEventRepeat || !itemGroupRepeat) {
        return undefined;
    }

    const itemGroupConfiguration = createItemGroupConfiguration(
        metadata,
        trialConfigurationItems,
        configurationItems,
        trial,
        isGlobal,
        configurationSourceDataId,
        studyEventOid,
        caseReportFormOid,
        caseReportFormVersionOid,
        itemGroupName
    )

    if (!itemGroupConfiguration) {
        return undefined;
    }

    // const sourceDataItemGroup = sourceDataItems?.[studyEventOid!]?.[studyEventRepeat]?.[caseReportFormOid!]?.[itemGroupName!]?.[itemGroupRepeat];

    if (!itemGroupConfiguration.configuration?.enabled) {
        return undefined;
    }

    return {
        ...itemGroupConfiguration,
        trial,
        masterGroup, 
        coordinatingGroup,
        institution,
        participant,
        preview,
        id: caseReportFormOid as any as number,
        status: ConfigurationStatus.Enabled,
        studyEventRepeat: studyEventRepeat,
        itemGroupRepeat: itemGroupRepeat
    };
}

const useItemGroup = (
    metadata?: Metadata, 
    trialConfiguration?: ConfigurationSourceDataMap, 
    configuration?: ConfigurationSourceDataMap, 
    sourceData?: SourceData,
    trial?: Trial, 
    masterGroup?: MasterGroup,
    coordinatingGroup?: CoordinatingGroup,
    institution?: Institution,
    participant?: Participant,
    studyEventOid?: string,
    studyEventRepeat?: number,
    caseReportFormOid?: string,
    caseReportFormVersionOid?: string,
    itemGroupName?: string,
    itemGroupRepeat?: number,
    preview?: boolean
) => {
    return useMemo(() => {
        return createItemGroup(
            metadata, 
            trialConfiguration?.itemGroups, 
            configuration?.itemGroups,
            sourceData?.items, 
            trial, 
            masterGroup,
            coordinatingGroup,
            institution,
            participant,
            configuration?.configuration?.isGlobal,
            configuration?.configuration?.id, 
            studyEventOid,
            studyEventRepeat,
            caseReportFormOid,
            caseReportFormVersionOid,
            itemGroupName,
            itemGroupRepeat,
            preview
        );
    }, [
        metadata, 
        trialConfiguration?.forms, 
        configuration?.forms, 
        sourceData?.forms, 
        trial, 
        masterGroup, 
        coordinatingGroup,
        institution, 
        participant, 
        studyEventOid, 
        studyEventRepeat,
        caseReportFormOid,
        caseReportFormVersionOid,
        itemGroupName,
        itemGroupRepeat,
        preview
    ]);
};

export default useItemGroup;